import React, { useEffect } from 'react';
import { Form, Input, Checkbox, Row, Col, Typography, Descriptions } from 'antd';
const { Title, Text } = Typography;

interface ReportData {
  reportNumber?: string;
  titleCompany?: string;
  address?: string;
  time?: string;
  cmaChecked?: boolean;
  cnasChecked?: boolean;
  rules: {
    firstPageCount?: number | string,
    lastPageCount?: number | string,
    testResultCount?: number | string,
    contentCount?: number | string,
    totalCount?: number | string,
    othersCount?: number | string
  };
}

interface ReportInfoProps {
  reportData: ReportData;
}

const ReportInfo: React.FC<ReportInfoProps> = ({ reportData }) => {
  const [form] = Form.useForm();

  // 同步更新表单值
  useEffect(() => {
    form.setFieldsValue({
      reportNumber: reportData.reportNumber,
      titleCompany: reportData.titleCompany,
      address: reportData.address,
      time: reportData.time,
    });
  }, [form, reportData]);

  return (
    <div style={{ marginBottom: '5px', padding: '10px', background: '#fff', border: '1px solid #d9d9d9' }}>
      <Row gutter={8}>
        {/* 左侧：报告基本信息 */}
        <Col span={16}>
          <Form 
            form={form} 
            layout="horizontal"
            labelCol={{ span: 6 }} // 标签占 6 列
            wrapperCol={{ span: 18 }} // 输入框占 18 列
            initialValues={{
              reportNumber: reportData.reportNumber,
              titleCompany: reportData.titleCompany,
              address: reportData.address,
              time: reportData.time,
            }}
          >
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item label="报告编号" name="reportNumber">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="报告抬头公司" name="titleCompany">
                  <Input value={reportData.titleCompany} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="地址" name="address">
                  <Input value={reportData.address} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="时间" name="time">
                  <Input value={reportData.time} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="印章">
                  <Checkbox checked={reportData.cmaChecked} disabled>CMA章</Checkbox>
                  <Checkbox checked={reportData.cnasChecked} disabled>CNAS章</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>

        {/* 右侧：适用的规则 */}
        <Col span={8}>
          <div style={{ padding: '10px', border: '1px solid #d9d9d9', borderRadius: '4px' }}>
            <Title level={5} style={{ margin: 0, textAlign: 'center' }}>适用的规则</Title>
            <Text strong style={{ display: 'block', textAlign: 'center', fontSize: '24px', margin: '10px 0' }}>
              {reportData.rules.totalCount}条
            </Text>
            <Descriptions title="" >
              <Descriptions.Item label="首页规则">{reportData.rules.firstPageCount}</Descriptions.Item>
              <Descriptions.Item label="尾页规则">{reportData.rules.lastPageCount}</Descriptions.Item>
              <Descriptions.Item label="结果页规则">{reportData.rules.testResultCount}</Descriptions.Item>
              <Descriptions.Item label="正文规则">{reportData.rules.contentCount}</Descriptions.Item>
              <Descriptions.Item label="其他规则">{reportData.rules.othersCount}</Descriptions.Item>
            </Descriptions>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ReportInfo;